/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { BusinessPartnerUser, FeatureState } from '@msdyn365-commerce/retail-proxy';

/**
 * eCommerce feature flag that gates Cross Legal Entity inventory lookup.
 */
export const CROSS_ENTITY_INVENTORY_FEATURE_NAME = 'RetailCrossCompanyInventoryLookupEcommerceFeature';

/**
 * Returns true when the Cross-LE inventory lookup eCommerce feature is enabled.
 * @param featureState - The feature state list fetched via get-feature-state.
 * @returns True when the feature is enabled.
 */
export const isCrossCompanyInventoryLookupEcommerceEnabled = (featureState?: FeatureState[]): boolean =>
    featureState?.some(feature => feature.Name === CROSS_ENTITY_INVENTORY_FEATURE_NAME && feature.IsEnabled === true) ?? false;

/**
 * Returns true when the current user is a B2B (business partner) user.
 * The Cross-LE warehouse locator is a B2B-only surface.
 * @param businessPartnerUser - The current business partner user, if any.
 * @returns True when the user is a business partner user.
 */
export const isBusinessPartnerUser = (businessPartnerUser?: BusinessPartnerUser): boolean =>
    businessPartnerUser !== undefined && businessPartnerUser !== null;
